// profiles
import SoapBoxDropper from "./images/profiles/SoapBoxDropper_withStory.png";
import HypeScan from "./images/profiles/HypeScan_withStory.png";
import SourceSniffer from "./images/profiles/SourceSniffer_withStory.png";
import ChaoticLOL from "./images/profiles/ChaoticLOL_withStory.png";
import LurksALot from "./images/profiles/LurksALot_withStory.png";

import RageSpark from "./images/profiles/RageSpark.png";
import MemeFiend from "./images/profiles/MemeFiend.png";
import TruthLeakerX from "./images/profiles/TruthLeakerX.png";
import CloutGoblin from "./images/profiles/CloutGoblin.png";
import ConcernedAuntie93 from "./images/profiles/ConcernedAuntie93.png";

import default_img from "./images/profiles/default.png";

// small profiles
import SoapBoxDropper_small from "./images/profiles/mini/SoapBoxDropper_small.png";
import HypeScan_small from "./images/profiles/mini/HypeScan_small.png";
import SourceSniffer_small from "./images/profiles/mini/SourceSniffer_small.png";
import ChaoticLOL_small from "./images/profiles/mini/ChaoticLOL_small.png";
import LurksALot_small from "./images/profiles/mini/LurksALot_small.png";

import RageSpark_small from "./images/profiles/mini/RageSpark_small.png";
import MemeFiend_small from "./images/profiles/mini/MemeFiend_small.png";
import TruthLeakerX_small from "./images/profiles/mini/TruthLeakerX_small.png";
import CloutGoblin_small from "./images/profiles/mini/CloutGoblin_small.png";
import ConcernedAuntie93_small from "./images/profiles/mini/ConcernedAuntie93_small.png";

// Teen profiles
import teenProfileGullibleSharer from "./images/teenProfileSummary/GullibleSharer.png";
import teenProfileCuriousBeliever from "./images/teenProfileSummary/CuriousBeliever.png";
import teenProfileCautiousExplorer from "./images/teenProfileSummary/CautiousExplorer.png";
import teenProfileSharpEyedAnalyst from "./images/teenProfileSummary/SharpEyedAnalyst.png";
import teenProfileMixedScanner from "./images/teenProfileSummary/MixedScanner.PNG";

import sharpEyedAnalyst from "./images/profiles/sharpEyedAnalyst.png";
import unsureScroller from "./images/profiles/unsureScroller.png"; 
import gullibleSharer from "./images/profiles/gullibleSharer.png";
import thoughtfulChecker from "./images/profiles/thoughtfulChecker.png";
import chaosClicker from "./images/profiles/chaoticClicker.png";
import allinSkeptic from "./images/profiles/allinSkeptic.png";
import upsideDownCritic from "./images/profiles/upsideDownCritic.png";

import teenBg_default from "./images/backgrounds/teenBg_default.png";
import teenBg_emotions from "./images/backgrounds/teenBg_emotions.png";
import teenBg_expert from "./images/backgrounds/teenBg_expert.png";
import teenBg_conspiracies from "./images/backgrounds/teenBg_conspiracies.png";

import logo from "./images/logo_new.png";
import wolpertinger from "./images/wolpertinger.png";
import headline_blank from "./images/Headline_blank.png";
import StirringEmotion from "./images/StirringEmotion.PNG";

import topic1 from "./images/politicsInternet.png";
import topic2 from "./images/healthInternet.png";
import topic3 from "./images/assortedInternet.png";

import s_disagree from "./images/likert/s_disagree.png";
import s_agree from "./images/likert/s_agree.png";
import neutral from "./images/likert/neutral.png";
import agree from "./images/likert/agree.png";
import disagree from "./images/likert/disagree.png";

import never from "./images/likert/never.svg";
import almostNever from "./images/likert/almost-never.svg";
import sometimes from "./images/likert/sometimes.svg";
import almostAlways from "./images/likert/almost-always.svg";
import always from "./images/likert/always.svg";

import truth_seeker_mode from "./images/truth_seeker_mode.png";
import chaos_mode from "./images/chaos_mode.png";

// import modeSelectorBg from "./images/modeSelectorBg.png";
import topicsBg from "./images/bgTopics.png";
import seal  from "./images/seal.png";
import crowd from "./images/crowd.png";
import badgeCropped from "./images/badgeCropped3.png";
import smallDotsBg from "./images/smallDotsBg.png";
import sbBackground from "./images/sbBackground.png";
import profileFolder from "./images/profileFolder.png";
import dotsBgProfiles from "./images/dotsBgProfiles.png";

import marcusThrone from "./images/marcusThrone.png";
import IngridFalkenstein from "./images/IngridFalkenstein.png";
import callieFrey from "./images/callieFrey.PNG";


import risk from "./images/risk.png";
import noRisk from "./images/noRisk.png";

import fact_checking from "./images/stickers/fact_checking.png";
import conspiracies from "./images/stickers/conspiracies.png";
import leveled_up from "./images/stickers/leveled_up.png";
import defender from "./images/stickers/defender.png";
import headline_check  from "./images/stickers/headline_check.png";
import is_this_even_true  from "./images/stickers/is_this_even_true.png";
import swamp  from "./images/stickers/swamp.png";
import shout  from "./images/stickers/shout.png";
import verified  from "./images/stickers/verified.png";
import that_friend  from "./images/stickers/that_friend.png";

//teenGameIntroAnimation
import modeSelectorBg from "./images/teenGame_startScreen/guy_phone.png";
import headerGame from "./images/teenGame_startScreen/game_text.png";
import headerOn from "./images/teenGame_startScreen/on_text.png";
import factCheckerAsset from "./images/teenGame_startScreen/TruthSeaker_lilac.png";
import chaosModeAsset from "./images/teenGame_startScreen/misinformation_spreader.png";
import truth_seeker from "./images/teenGame_startScreen/truth_seeker.png";

import textSpeedIcon from "./images/speed.png";
import textSizeIcon from "./images/fontSize.png";
import settingsIcon from "./images/settingsIcon.png";
import jkuLIT from "./images/jkuCP.png";
import jkuCP from "./images/jkuLIT.png";
import emailIcon from "./images/emailIcon.png";
import messengerIcon from "./images/messengerIcon.png";
import choiceIcon from "./images/choiceIcon.png";
import ageIcon from "./images/ageIcon.png";
import tobaccoIcon from "./images/tobaccoIcon.png";
import flowerIcon from "./images/flowerIcon.png";
import runningIcon from "./images/runningIcon.png";

import illustrationGameP1 from "./images/illustrationGame/example_page1.png";
import illustrationGameP2 from "./images/illustrationGame/example_page2.png";

const ImgBuilder = {
    SoapBoxDropper,
    HypeScan,
    SourceSniffer,
    ChaoticLOL,
    LurksALot,

    RageSpark,
    MemeFiend,
    TruthLeakerX,
    CloutGoblin,
    ConcernedAuntie93,

    SoapBoxDropper_small,
    HypeScan_small,
    SourceSniffer_small,
    ChaoticLOL_small,
    LurksALot_small,

    RageSpark_small,
    MemeFiend_small,
    TruthLeakerX_small,
    CloutGoblin_small,
    ConcernedAuntie93_small,

    sharpEyedAnalyst,
    unsureScroller,
    gullibleSharer,
    thoughtfulChecker,
    chaosClicker,
    allinSkeptic,
    upsideDownCritic,

    teenProfileGullibleSharer,
    teenProfileCuriousBeliever,
    teenProfileCautiousExplorer,
    teenProfileSharpEyedAnalyst,
    teenProfileMixedScanner,

    teenBg_default,
    teenBg_emotions,
    teenBg_expert,
    teenBg_conspiracies,

    IngridFalkenstein,
    marcusThrone,
    callieFrey,

    default_img,
    modeSelectorBg,
    topicsBg,
    seal,
    crowd,
    badgeCropped,
    smallDotsBg,
    StirringEmotion,
    sbBackground,
    profileFolder,
    dotsBgProfiles,


    headerGame,
    headerOn,
    factCheckerAsset,
    chaosModeAsset,
    truth_seeker,

    risk,
    noRisk,
    
    topic1,
    topic2,
    topic3,



    logo,
    wolpertinger,
    headline_blank,
    chaos_mode,
    truth_seeker_mode,

    s_disagree,
    s_agree,
    neutral,
    agree,
    disagree,
    
    never,
    almostNever,
    sometimes,
    almostAlways,
    always,

    fact_checking,
    conspiracies,
    leveled_up,
    defender,
    headline_check,
    is_this_even_true,
    swamp,
    shout,
    verified,
    that_friend,

    textSpeedIcon,
    textSizeIcon,
    settingsIcon,
    jkuLIT,
    jkuCP,
    emailIcon,
    messengerIcon,
    choiceIcon,
    ageIcon,
    tobaccoIcon,
    flowerIcon,
    runningIcon,

    illustrationGameP1,
    illustrationGameP2
}

export default ImgBuilder;